// extracted by mini-css-extract-plugin
export var p_table = "styles-module--p_table--352a1";